export default __webpack_public_path__ + "static/media/mom.de6713c5.png";